import { getTenantConfig } from 'utils/tenant';

export const STEPS = {
  PICK_A_REASON: "PICK_A_REASON",
  PICK_A_TIME: "PICK_A_TIME",
  REVIEW_APPOINTMENT: "REVIEW_APPOINTMENT",
  CHANGE_DURATION: "CHANGE_DURATION",
  ADD_COURSE: "ADD_COURSE",
  CONFIRMATION_SCREEN: "CONFIRMATION_SCREEN"
};

export const getPreviousStep = step => {
  switch ( step ) {
    case STEPS.PICK_A_TIME:
      return STEPS.PICK_A_REASON;
    case STEPS.REVIEW_APPOINTMENT:
      return STEPS.PICK_A_TIME;
    case STEPS.CHANGE_DURATION:
    case STEPS.ADD_COURSE:
    case STEPS.CONFIRMATION_SCREEN:
      return STEPS.REVIEW_APPOINTMENT;
    default:
      return step;
  }
}

export const getNextStep = step => {
  switch ( step ) {
    case STEPS.PICK_A_REASON:
      return STEPS.PICK_A_TIME;
    case STEPS.PICK_A_TIME:
    case STEPS.CHANGE_DURATION:
      return STEPS.REVIEW_APPOINTMENT;
    case STEPS.ADD_COURSE:
      return STEPS.REVIEW_APPOINTMENT;
    case STEPS.REVIEW_APPOINTMENT:
      return STEPS.CONFIRMATION_SCREEN;
    default:
      return step;
  }
}

export const getFirstStep = () => STEPS.PICK_A_REASON;

export const shouldDisplayBackButton = step => step !== STEPS.PICK_A_REASON;

export const isReasonValid = reasonId => reasonId !== null && reasonId !== "";

export const isCourseValid = courseContextId => courseContextId !== null && courseContextId !== "";

export const isSlotValid = (startDate, ownerId) => startDate !== null && ownerId !== null;

export const canClickOnContinueButton = (step, params) => {
  switch ( step ) {
    case STEPS.PICK_A_REASON:
      return isReasonValid(params.reasonId);
    case STEPS.PICK_A_TIME:
    	return isSlotValid(params.startDate, params.ownerId) && !params.sectionInfoRetrievalInProgress;
    case STEPS.REVIEW_APPOINTMENT:
      return !params.confirming && !!params.locationId; // Only allow when not sending data and a location is selected
    case STEPS.CHANGE_DURATION:
      return true; // Always allow once we always will have an option selected
    case STEPS.ADD_COURSE:
      return isCourseValid(params.courseContextId);
    default:
      return false;
  }
}

export const defaultScheduleLinkForService = (serviceId) => {
  return `../appointments/signup.html?partyId=${serviceId}`;
}

export const defaultScheduleLinkForConnection = (connectionId) => {
  return `../appointments/appointments.html?instuid=${connectionId}&mode=makeAppointment`;
}

export const continueButtonText = (step, confirming, sectionInfoRetrievalInProgress) => {
  if ( step === STEPS.REVIEW_APPOINTMENT && confirming ) return "Confirming...";
  if ( step === STEPS.REVIEW_APPOINTMENT && !confirming) return "Confirm";
  if ( step === STEPS.CHANGE_DURATION || step === STEPS.ADD_COURSE) return "Save";
  if ( step === STEPS.PICK_A_TIME && sectionInfoRetrievalInProgress ) return "Continue...";
  return "Continue";
}

export const backButtonText = step => {
  if ( step === STEPS.CHANGE_DURATION || step === STEPS.ADD_COURSE) return "Cancel";
  return "Back";
}

export const roundToNextFiveMinute = (filterStartDate) => {
  filterStartDate = filterStartDate.add(1, 'minute');
  return filterStartDate.add(5 - (filterStartDate.minute() % 5), 'minute').startOf('minute');
}

const shuffleSlots = (sortedSlots, randomizedSlots) => {
  sortedSlots.map((slotA) => ({sort: Math.random(), value: slotA}))
        .sort((slotA, slotB) => slotA.sort - slotB.sort)
        .map((slotA) => randomizedSlots.push(slotA.value))
}

export const sortSlots = (slots) => {
  if (getTenantConfig('SERVICE_PROVIDER_RANDOMIZATION_ENABLED')) {
    let randomizedSlots = [];
    let sortedSlots = [];
    let sortableKey = "";
    slots.map((item, index) => {
      let itemKey = item.startDate + (item.durationsMinutes && item.durationsMinutes[0] ? item.durationsMinutes[0].toString() : '')
      if (sortableKey === itemKey) {
        sortedSlots.push(item)
      } else {
        sortableKey = itemKey
        if (index !== 0) {
          shuffleSlots(sortedSlots, randomizedSlots)
        }
        sortedSlots = []
        sortedSlots.push(item)
      }
      if (index === (slots.length - 1)) {
        shuffleSlots(sortedSlots, randomizedSlots)
      }
    })
    return randomizedSlots
  }
  return slots
}
